import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaisirConstatComponent } from './modals/saisir-constat/saisir-constat.component';
import { Controle } from 'src/app/data/declaration/models/controle.model';
import { NatureControle } from 'src/app/data/declaration/models/nature-controle.model';
import moment from 'moment';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ReferentielService } from 'src/app/data/declaration/services/referentiel/referentiel.service';
import { forkJoin } from 'rxjs';
import { ControlesService } from 'src/app/data/declaration/services/controles/controles.service';
import { SessionContext } from 'src/app/core/services/config/app.settings';
import { ControleResultat } from 'src/app/data/declaration/models/controle-resultat.model';
import { StatutControle } from 'src/app/data/declaration/models/statut-controle.model';
import { TypeControle } from 'src/app/data/declaration/models/type-controle.model';
import { Animateur } from 'src/app/data/commission/models/animateur.model';
import { AnimateursService } from 'src/app/data/commission/services/animateurs/animateurs.service';
import { SyntheseConstatsComponent } from './modals/synthese-constats/synthese-constats.component';
import { SaisieLot } from 'src/app/data/declaration/interfaces/saisie-lot.interface';
import { Manquement } from 'src/app/data/declaration/models/manquement.model';
import { LaboratoiresService } from 'src/app/data/declaration/services/laboratoires/laboratoires.service';
import { Laboratoire } from 'src/app/data/declaration/models/laboratoire.model';
import { ActivitesService } from 'src/app/data/habilitation/services/activites/activites.service';
import { Activite } from 'src/app/data/habilitation/models/activite.model';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { CategorieEnum } from 'src/app/data/edition/models/enums/categorie.enum.model';
import { TelechargerDocumentComponent } from '../../../main/components/telecharger-document/telecharger-document.component';
import { LeurresService } from '../../../../../data/commission/services/leurres/leurres.service';
import { map, switchMap } from 'rxjs/operators';
import { EvaluationJureComponent } from './modals/evaluation-jure/evaluation-jure.component';
import { LeurreSearch } from '../../../../../data/commission/models/leurre-search.model';
import { ResultatControleComponent } from './modals/resultat-controle/resultat-controle.component';
import { ManquementsService } from '../../../../../data/declaration/services/manquements/manquements.service';
import { ManquementRecoursComponent } from './modals/manquement-recours/manquement-recours.component';
import { Cahier } from '../../../../../data/habilitation/models/cahier.model';
import { CahiersService } from '../../../../../data/commission/services/cahiers/cahiers.service';
import { CommissionsService } from '../../../../../data/commission/services/commissions/commissions.service';
import { Commission } from '../../../../../data/commission/models/commission.model';
import { CommissionFilter } from '../../../../../data/commission/models/commission-filter.model';
import { LoaderService } from '../../../../../core/services/loader/loader.service';
import {Router} from "@angular/router";

@Component({
    selector: 'app-suivi-controles',
    templateUrl: './suivi-controles.component.html',
    styleUrls: ['./suivi-controles.component.scss'],
    standalone: false
})
export class SuiviControlesComponent implements OnInit {
    private idOrganisme: number;
    public controleResultat: ControleResultat;
    public formSearchControles: UntypedFormGroup;
    public refNatures: NatureControle[];
    public refStatuts: StatutControle[];
    public refTypes: TypeControle[];
    public animateurs: Animateur[];
    public activites: Activite[];
    public refLaboratoires: Laboratoire[];
    public controles: Controle[] = [];
    public estFiltreAnalytique = false;
    public estFiltreOrganoleptique = false;
    public estRechercheAnalytique = false;
    public estRechercheOrganoleptique = false;
    showAdvancedFilters = false;
    pagination: {
        loadPages: (() => {})[];
        loadPrev: () => {};
        loadNext: () => {};
        length: number;
        start: number;
        end: number;
        maxRange: number;
        currentPage: number;
    };

    get nature() {
        return this.formSearchControles.get('nature');
    }

    get statuts() {
        return this.formSearchControles.get('statuts');
    }

    get types() {
        return this.formSearchControles.get('types');
    }

    get agents() {
        return this.formSearchControles.get('agents');
    }

    get debutDateControle() {
        return this.formSearchControles.get('debutDateControle');
    }

    get finDateControle() {
        return this.formSearchControles.get('finDateControle');
    }

    get laboratoire() {
        return this.formSearchControles.get('laboratoire');
    }

    get numeroEchantillon() {
        return this.formSearchControles.get('numeroEchantillon');
    }

    get numeroCommission() {
        return this.formSearchControles.get('numeroCommission');
    }

    get numeroCVI() {
        return this.formSearchControles.get('numeroCVI');
    }

    get laboratoires() {
        return this.formSearchControles.get('laboratoires');
    }

    /**
     * Getter cahier
     */
    get cahier() {
        return this.formSearchControles.get('cahier');
    }

    /**
     * Liste des leurres
     */
    leurres: LeurreSearch[] = [];

    /**
     * True si résultat de recherche
     */
    isResultat = false;

    /**
     * Liste des cahiers des charges
     */
    cahiers: Cahier[] = [];

    /**
     * Liste des commissions
     */
    commissions: CommissionFilter[] = [];

    /**
     * Id de la commission en provenance de l'url
     */
    initialIdCommission: number;

    getLibelles(items: any[], property: string): string {
        if (!items?.length) {
            return '';
        }

        return items
            .map(item => item?.[property])
            .filter(Boolean)
            .join(', ');
    }

    hasActiveFilters(): boolean {
        const formValue = this.formSearchControles?.value;

        return !!(
            formValue?.numeroEchantillon ||
            formValue?.numeroCVI ||
            formValue?.debutDateControle ||
            formValue?.finDateControle ||
            formValue?.types?.length ||
            formValue?.statuts?.length ||
            formValue?.cahier?.length ||
            formValue?.agents?.length ||
            formValue?.laboratoires?.length
        );
    }

    constructor(
        private readonly controleService: ControlesService,
        private readonly referentielService: ReferentielService,
        private readonly animateursService: AnimateursService,
        private readonly activiteService: ActivitesService,
        private readonly laboratoireService: LaboratoiresService,
        private readonly fb: UntypedFormBuilder,
        private readonly modalService: NgbModal,
        private readonly modalsService: ModalService,
        private readonly translate: TranslateService,
        private readonly leurresService: LeurresService,
        private readonly manquementService: ManquementsService,
        private readonly loaderService: LoaderService,
        private readonly cahiersService: CahiersService,
        private readonly commissionsService: CommissionsService,
        private readonly router: Router
    ) {
        // Instancier le formulaire de recherche
        this.formSearchControles = this.fb.group({
          nature: [undefined, Validators.required],
          statuts: undefined,
          types: undefined,
          agents: undefined,
          debutDateControle: undefined,
          finDateControle: undefined,
          laboratoire: undefined,
          numeroEchantillon: undefined,
          numeroCommission: undefined,
          numeroCVI: undefined,
          laboratoires: undefined,
          cahier: undefined,
        });

        // Récupérer le type de contrôle et la commission via l'url
        const state = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state;
        if (state) {
          this.nature.setValue(state.controle);
          this.estFiltreOrganoleptique = true;
          this.initialIdCommission = state.commission;
        }
    }

    ngOnInit() {
        // Récupérer l'ID organisme
        this.idOrganisme = SessionContext.get('idOrganisme');

        this.loadData();
    }

    private loadData(): void {
        forkJoin([
            this.animateursService.getAnimateurs(this.idOrganisme),
            this.laboratoireService.getLaboratoire(this.idOrganisme),
            this.referentielService.getReferentiel(),
            this.activiteService.getActivites(),
            this.cahiersService.getCahiers(),
            this.commissionsService.getCommissionsFilter(this.idOrganisme)
        ]).subscribe(([animateurs, laboratoires, referentiel, activites, cahiers, commissions]) => {
            this.animateurs = animateurs;
            this.activites = activites;
            this.refLaboratoires = laboratoires;
            this.refNatures = referentiel.naturesControle;
            this.refStatuts = referentiel.statutsControle;
            this.refTypes = referentiel.typesControle;
            animateurs.map(animateur => (animateur.nomComplet = animateur.nom + ' ' + animateur.prenom));
            this.cahiers = cahiers.sort((a, b) => a.libelle.localeCompare(b.libelle));
            this.commissions = commissions.sort((a, b) => b.dateDebut.valueOf() - a.dateDebut.valueOf());
            if (this.initialIdCommission) {
              this.numeroCommission.setValue(this.commissions.find(commission => commission.id === this.initialIdCommission));
            }
        });
    }

    private getMomentDate(date: { year: number; month: number; day: number }): moment.Moment {
        return date ? moment([date.year, date.month - 1, date.day, 0, 0, 0]) : null;
    }

    public updateStatut(controle: Controle) {
        this.modalsService
            .confirm(
                this.translate.instant('page.controles.controles.modalConfirmText'),
                this.translate.instant('page.controles.controles.modalConfirmTitle'),
                {
                    cancelText: this.translate.instant('label.annuler'),
                    submitText: this.translate.instant('label.valider')
                }
            )
            .then(
                () => {
                    controle.idStatut = this.refStatuts.find(statut => statut.code === 'TERMINE').id;
                    controle.statut = this.refStatuts.find(statut => statut.code === 'TERMINE');
                    this.controleService.modifierStatutControle(this.idOrganisme, controle).subscribe();
                },
                () => {}
            );
    }

    public deleteControle(controle: Controle): void {
        this.modalsService
            .confirm(
                this.translate.instant('page.controles.controles.modalConfirmSuppressionText'),
                this.translate.instant('page.controles.controles.modalConfirmSuppressionTitle'),
                {
                    cancelText: this.translate.instant('label.annuler'),
                    submitText: this.translate.instant('label.valider')
                }
            )
            .then(
                () => {

                    console.log(controle);
                    this.controleService
                        .supprimerControle(this.idOrganisme, controle)
                        .subscribe(() => {
                            this.controles = this.controles.filter(
                                c => c.id !== controle.id
                            );
                        });
                },
                () => {}
            );
    }

    public onSubmit(): void {
        this.isResultat = false;
        if (this.formSearchControles.valid) {
            const nature = this.nature.value;
            const statuts = this.statuts.value && this.statuts.value.length > 0 ? this.statuts.value.map(statut => statut.id) : undefined;
            const types = this.types.value && this.types.value.length > 0 ? this.types.value.map(type => type.id) : undefined;
            const agents = this.agents.value && this.agents.value.length > 0 ? this.agents.value.map(agent => agent.id) : undefined;
            const laboratoires = this.laboratoires.value ? this.laboratoires.value.map(laboratoire => laboratoire.id) : undefined;
            const debutDateControle = this.debutDateControle.value;
            const finDateControle = this.finDateControle.value;
            const numeroEchantillon = this.numeroEchantillon.value;
            const idCommission = this.numeroCommission.value ? this.numeroCommission.value.id : undefined;
            const numeroCommission = this.numeroCommission.value ? this.numeroCommission.value.numero : undefined;
            const numeroCVI = this.numeroCVI.value;
            const idCahiers = this.cahier.value && this.cahier.value.length > 0 ? this.cahier.value.map(cahier => cahier.id) : undefined;
            const libelleCahiers = this.cahier.value && this.cahier.value.length > 0 ? this.cahier.value.map(cahier => cahier.libelle) : undefined;

            const natureSelectionnee: NatureControle = this.refNatures.find(n => n.id === this.nature.value);
            if (natureSelectionnee.code === 'ORGANOLEPTIQUE') {
                this.estRechercheAnalytique = false;
                this.estRechercheOrganoleptique = true;
            } else if (natureSelectionnee.code === 'ANALYTIQUE') {
                this.estRechercheAnalytique = true;
                this.estRechercheOrganoleptique = false;
            } else {
                this.estRechercheAnalytique = false;
                this.estRechercheOrganoleptique = false;
            }

            this.controleService
                .getFilteredControles(
                    this.idOrganisme,
                    nature,
                    statuts,
                    types,
                    agents,
                    laboratoires,
                    this.getMomentDate(debutDateControle),
                    this.getMomentDate(finDateControle),
                    numeroEchantillon,
                    idCommission,
                    numeroCVI,
                    idCahiers
                )
                .pipe(
                    switchMap(controleResultat => {
                        const controles = controleResultat.response.controles;
                        this.pagination = controleResultat.pagination;

                        return this.leurresService
                            .getCommissionLeurres(
                                this.idOrganisme,
                                this.getMomentDate(debutDateControle),
                                this.getMomentDate(finDateControle),
                                numeroCommission,
                                numeroCVI,
                                numeroEchantillon,
                                libelleCahiers
                            )
                            .pipe(
                                map(leurres => {
                                    this.leurres = leurres;
                                    leurres.forEach(leurre => {
                                        const controle = new Controle();
                                        controle.idLeurre = leurre.idLeurre;
                                        controle.isLeurre = true;
                                        controle.dateControle = leurre.dateCommission;
                                        controle.libelleProduit = leurre.libelleProduit;
                                        controle.raisonSociale = `LEURRE (${leurre.libelleTypeLeurre})`;
                                        controle.numeroJury = leurre.numeroJury.toString();
                                        controle.numeroAnonymat = leurre.numeroAnonymat;
                                        controle.numeroCommission = leurre.numeroCommission;
                                        controles.push(controle);
                                    });

                                    return controles;
                                })
                            );
                    })
                )
                .subscribe(controles => {
                    this.isResultat = true;
                    this.controles = controles;
                });
        }
    }

    getCVI(resultat: Controle): string {
        try {
            return resultat.infosOperateur.find(infos => !!~infos.code.indexOf('CVI')).valeur;
        } catch (e) {
            return '';
        }
    }

    getLibelleCahier(resultat: Controle): string[] {
        const libellesCahier = resultat.cahiers.map(cahier => cahier.libelle);
        return libellesCahier ? libellesCahier : null;
    }

    getNomAgent(resultat: Controle): string {
        const animateur = this.animateurs.find(animateur => animateur.id === resultat.idAgent);
        return animateur ? `${animateur.nom} ${animateur.prenom}` : '';
    }

    getLibelleActivite(resultat: Controle): string {
        const libelleActivite = resultat.activites.map(activite => activite.libelle);
        return libelleActivite ? libelleActivite.join(',') : '';
    }

    getLibelleProduit(resultat: Controle): string[] {
        const libelleList = resultat.produits.map(produit => produit.libelle);
        return libelleList ? libelleList : null;
    }

    changeNature() {
        const natureSelectionnee: NatureControle = this.refNatures.find(nature => nature.id === this.nature.value);
        if (natureSelectionnee.code === 'ORGANOLEPTIQUE') {
            this.estFiltreAnalytique = false;
            this.estFiltreOrganoleptique = true;
        } else if (natureSelectionnee.code === 'ANALYTIQUE') {
            this.estFiltreAnalytique = true;
            this.estFiltreOrganoleptique = false;
        } else {
            this.estFiltreAnalytique = false;
            this.estFiltreOrganoleptique = false;
        }
    }

    /**
     * Initie une saisie par lot de manquements sur un contrôle donné
     * @param controle Le contrôle à invalider
     * @param lot Un lot en cours de saisie
     */
    public addConstat(controle: Controle, lot: SaisieLot<Manquement[]> = undefined): void {
        // Ouvrir la modale de saisie
        const modalSaisie = this.modalService.open(SaisirConstatComponent, {
            backdrop: 'static',
            windowClass: 'app-modal-1000px'
        });
        modalSaisie.componentInstance.controle = controle;
        if (lot) {
            modalSaisie.componentInstance.saisieLot = lot;
        }

        // Ouvrir la modale de synthèse du lot
        modalSaisie.result.then(
            constatsManquements => {
                const modalSynthese = this.modalService.open(SyntheseConstatsComponent, {
                    backdrop: 'static',
                    windowClass: 'app-modal-1000px'
                });
                modalSynthese.componentInstance.controle = controle;
                modalSynthese.componentInstance.manquements = constatsManquements;

                modalSynthese.result.then(
                    (lot: SaisieLot<Manquement[]>) => {
                        if (lot && lot.saisieTerminee) {
                            // Recharger la page courante
                            this.pagination.loadPages[this.pagination.currentPage]();
                        } else if (lot) {
                            // Ré-ouvrir la modal de saisie de manquements
                            this.addConstat(controle, lot);
                        }
                    },
                    () => {}
                );
            },
            () => {}
        );
    }

    // public telechargerDocument(controle: Controle) {
    //   const modalRef = this.modalService.open(TelechargerDocumentComponent, { size: 'lg', backdrop: 'static' });
    //   modalRef.componentInstance.controle = controle;
    //   modalRef.componentInstance.categorie = CategorieEnum.CONTROLE;
    //   modalRef.result.then(
    //     () => { },
    //     error => { throw error; }
    //   );
    // }

    public telechargerDocument() {
        if (this.controles.length < 40) {
            const modalRef = this.modalService.open(TelechargerDocumentComponent, { size: 'lg', backdrop: 'static' });
            modalRef.componentInstance.controle = this.controles;
            modalRef.componentInstance.categorie = CategorieEnum.CONTROLE;
            modalRef.result.then(
                () => {},
                error => {
                    throw error;
                }
            );
        } else {
        }
    }

    public envoyerDocumentsMail() {
        const modalRef = this.modalService.open(TelechargerDocumentComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.controle = this.controles;
        modalRef.componentInstance.categorie = CategorieEnum.CONTROLE;
        modalRef.componentInstance.commissionSendMail = true;
        modalRef.componentInstance.documentsIds = modalRef.result.then(
            () => {},
            error => {
                throw error;
            }
        );
    }

    /**
     * Ouvre modale évaluation des jurés
     */
    onOpenEvaluationJure(controle: Controle) {
        const modalRef = this.modalService.open(EvaluationJureComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.leurres = this.leurres;
        modalRef.componentInstance.controle = controle;
        modalRef.componentInstance.idOrganisme = this.idOrganisme;
        modalRef.result.then(
            () => {
                // La modale s’est fermée normalement avec .close()
            },
            reason => {
                // La modale a été dismissée avec .dismiss()
                console.warn('Modale fermée sans action :', reason);
            }
        );
    }

    /**
     * Modifie le resultat d'un controle
     * @param controle - Nombre de manquements
     */
    onModifyControle(controle: Controle) {
        if (controle.nbManquement > 0) {
            const modalRef = this.modalService.open(ResultatControleComponent, { size: 'lg', backdrop: 'static' });
            modalRef.result.then(confirmation => {
                if (confirmation) {
                    this.manquementService
                        .deleteManquement(controle.id)
                        .pipe(this.loaderService.operator())
                        .subscribe(result => {
                            if (result === 0) {
                                this.setControlStatutEnCours(controle);
                            } else if (result === -1) {
                                const modalRef2 = this.modalService.open(ManquementRecoursComponent, { size: 'lg', backdrop: 'static' });
                                modalRef2.result.then(() => {});
                            }
                        });
                }
            });
        } else {
            this.setControlStatutEnCours(controle);
        }
    }

    /**
     * Met à jour le statut d'un controle en EN_COURS
     * @param controle - Controle à modifier
     */
    setControlStatutEnCours(controle: Controle) {
        controle.idStatut = this.refStatuts.find(statut => statut.code === 'EN_COURS').id;
        controle.statut = this.refStatuts.find(statut => statut.code === 'EN_COURS');
        this.controleService.modifierStatutControle(this.idOrganisme, controle).subscribe();
    }
}
